import { useState } from 'react';
import { useFlatsDataContext } from '../../../../../../../../contexts/FlatsDataContext';

import styles from './FlatAvailableFilter.module.css';

const FlatAvailableFilter: React.FC<{}> = (): JSX.Element => {
    const [selectedFilters, setSelectedFilters] = useState<string[]>(['all']);
    const { setFilterAvailable } = useFlatsDataContext();

    /**
     * Handles the Available selection of filters, updating the selected filters based on the selected option.
     * If 'all' is selected, it resets filters to only include 'all' (Wszystkie). Otherwise, it toggles the specified filter.
     * @param {string} filter - The filter option selected ('all', 'available', 'sold', 'reserved').
     * @returns {void}
    */
    const handleFilterSelect = (filter: string): void => {
        if (filter === 'all') {
            setSelectedFilters(['all']);
            setFilterAvailable(['all']);
        } else {
            setSelectedFilters(prevFilters => {
                const filtersWithoutAll = prevFilters.filter(f => f !== 'all');

                if (filtersWithoutAll.includes(filter)) {
                    setFilterAvailable(filtersWithoutAll.filter(f => f !== filter))
                    return filtersWithoutAll.filter(f => f !== filter);
                } else {
                    setFilterAvailable([...filtersWithoutAll, filter])
                    return [...filtersWithoutAll, filter];
                }
            });
        }
    };

    return (
        <div className={styles.wrapper}>
            <button
                className={`${styles.filterButton} ${selectedFilters.includes('all') || selectedFilters.length === 0 ? styles.active : ''}`}
                onClick={() => handleFilterSelect('all')}
            >
                Wszystkie
            </button>
            <button
                className={`${styles.filterButton} ${selectedFilters.includes('dostepne') ? styles.active : ''}`}
                onClick={() => handleFilterSelect('dostepne')}
            >
                Dostępne
            </button>
            <button
                className={`${styles.filterButton} ${selectedFilters.includes('rezerwacja') ? styles.active : ''}`}
                onClick={() => handleFilterSelect('rezerwacja')}
            >
                Rezerwacja
            </button>
            <button
                className={`${styles.filterButton} ${selectedFilters.includes('sprzedane') ? styles.active : ''}`}
                onClick={() => handleFilterSelect('sprzedane')}
            >
                Sprzedane
            </button>
        </div>
    );
};

export default FlatAvailableFilter;